import axios from 'axios';
import { apiBaseUrl } from '../config';
import { installVianaHeaders } from './axiosConfig';

/**
 * Client for this repo's own BFF (apps/api). Separate from the global axios instance so a demo
 * calling an upstream Viana service directly cannot accidentally inherit BFF-only settings.
 *
 * installVianaHeaders is NOT optional here: an axios.create() instance starts with an empty
 * interceptor manager, so without this call every request to the BFF goes out with no bearer
 * token and the API — correctly — answers 401.
 */
export const apiClient = installVianaHeaders(
  axios.create({
    baseURL: apiBaseUrl,
    timeout: 20_000,
  }),
);

export async function apiGet<T>(path: string, params?: Record<string, unknown>): Promise<T> {
  const { data } = await apiClient.get<T>(path, { params });
  return data;
}
